<mat-card style="background: #FFFFFF !important; border: none !important; border-radius: 6px !important; padding: 13px 22px !important;">
    <mat-card-header>
        <mat-card-title>
          {{'title.link_account' | translate}}
        </mat-card-title>
    </mat-card-header>

    <mat-card-content class="mb-3">
        <mat-accordion #accordion="matAccordion" [multi]="true">
            <div class="row">
              <!-- Liên kết apple -->
              <div class="col-12 d-flex justify-content-between align-items-center" style="margin: 14px 0; padding: 0 12px;">
                <div class="d-flex align-items-center" style="min-width: 30%;">
                  <svg style="width: 24px; height: 24px; min-width: 24px;" class="mr-2" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.4587 10.6263C15.4337 8.09375 17.5237 6.87875 17.6175 6.81875C16.4425 5.1 14.6125 4.86375 13.96 4.8375C12.4025 4.68 10.9212 5.755 10.13 5.755C9.34123 5.755 8.12123 4.86125 6.82998 4.885C5.13248 4.91 3.56748 5.8725 2.69248 7.3925C0.928728 10.4525 2.24123 14.9875 3.95998 17.4688C4.79998 18.6838 5.80123 20.0487 7.11623 20C8.38248 19.95 8.86123 19.18 10.3925 19.18C11.9237 19.18 12.3537 20 13.6937 19.9738C15.0562 19.9487 15.92 18.735 16.7537 17.5162C17.7187 16.1062 18.115 14.7425 18.1387 14.6725C18.1087 14.6587 15.4812 13.6525 15.455 10.6275L15.4587 10.6263ZM12.9412 3.19375C13.6387 2.3475 14.11 1.1725 13.9812 0C12.9762 0.04125 11.7575 0.67 11.0362 1.515C10.3887 2.265 9.82248 3.46125 9.97373 4.61C11.0962 4.6975 12.2425 4.04 12.94 3.195L12.9412 3.19375Z" fill="black"/>
                  </svg>
                  <span *ngIf="!hasAppleLink" class="ml-2">
                    {{ 'Apple' | translate }}
                  </span>
                  <div *ngIf="hasAppleLink" class="ml-2">
                    <div class="text-left">{{ accountApple.name }}</div>
                    <div class="text-left">{{ accountApple.linkedDate | date:'dd/MM/yyyy' }}</div>
                  </div>
                </div>
                <div *ngIf="hasAppleLink" class="email">{{ accountApple.email }}</div>
                <span *ngIf="!hasAppleLink" class="text-center" (click)="connectWidthFirebase(LINK_TYPE.APPLE)"><a style="color: #1890ff;">{{'linked_account.link' | translate}}</a></span>
                <span *ngIf="hasAppleLink" class="text-center" (click)="deleteConnectFirebase(LINK_TYPE.APPLE)"><a style="color: #FF0004;">{{'linked_account.delete_link' | translate}}</a></span>
              </div>
            </div>
            <div class="divider"></div>
            <div class="row">
              <!-- Liên kết apple -->
              <div class="col-12 d-flex justify-content-between align-items-center" style="margin: 14px 0; padding: 0 12px;">
                <div class="d-flex align-items-center" style="min-width: 30%;">
                  <svg style="width: 24px; height: 24px; min-width: 24px;"  class="mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 16.84 5.44 20.87 10 21.8V15H8V12H10V9.5C10 7.57 11.57 6 13.5 6H16V9H14C13.45 9 13 9.45 13 10V12H16V15H13V21.95C18.05 21.45 22 17.19 22 12Z" fill="#0980EB"/>
                  </svg>
                  <span  class="ml-2">
                  <!-- <span *ngIf="!hasFacebookLink" class="ml-2"> -->
                    {{ 'Facebook' | translate }}
                  </span>
                  <!-- <div *ngIf="hasFacebookLink" class="ml-2">
                    <div class="text-left">{{ accountApple.name }}</div>
                    <div class="text-left">{{ accountApple.linkedDate | date:'dd/MM/yyyy' }}</div>
                  </div> -->
                </div>
                <!-- <div *ngIf="hasFacebookLink" class="email">{{ accountApple.email }}</div>
                <span *ngIf="!hasFacebookLink" class="text-center" (click)="featureInDevelopment()"><a style="color: #1890ff;">{{'linked_account.link' | translate}}</a></span>
                <span *ngIf="hasFacebookLink" class="text-center" (click)="featureInDevelopment()"><a style="color: #FF0004;">{{'linked_account.delete_link' | translate}}</a></span> -->
                <span class="text-center" (click)="featureInDevelopment()"><a style="color: #1890ff;">{{'linked_account.link' | translate}}</a></span>
              </div>
            </div>
            <div class="divider"></div>
            <div class="row">
              <!-- Liên kết apple -->
              <div class="col-12 d-flex justify-content-between align-items-center" style="margin: 14px 0; padding: 0 12px;">
                <div class="d-flex align-items-center" style="min-width: 30%;">
                  <svg style="width: 24px; height: 24px; min-width: 24px;" class="mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21.8055 10.0415H21V10H12V14H17.6515C16.827 16.3285 14.6115 18 12 18C8.6865 18 6 15.3135 6 12C6 8.6865 8.6865 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C6.4775 2 2 6.4775 2 12C2 17.5225 6.4775 22 12 22C17.5225 22 22 17.5225 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z" fill="#FFC107"/>
                    <path d="M3.15302 7.3455L6.43851 9.755C7.32752 7.554 9.48052 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C8.15902 2 4.82802 4.1685 3.15302 7.3455Z" fill="#FF3D00"/>
                    <path d="M12 22.0001C14.583 22.0001 16.93 21.0116 18.7045 19.4041L15.6095 16.7851C14.6055 17.5456 13.3575 18.0001 12 18.0001C9.399 18.0001 7.1905 16.3416 6.3585 14.0271L3.0975 16.5396C4.7525 19.7781 8.1135 22.0001 12 22.0001Z" fill="#4CAF50"/>
                    <path d="M21.8055 10.0415H21V10H12V14H17.6515C17.2555 15.1185 16.536 16.083 15.608 16.7855L15.6095 16.7845L18.7045 19.4035C18.4855 19.6025 22 17 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z" fill="#1976D2"/>
                  </svg>
                  <span *ngIf="!hasGoogleLink" class="ml-2">
                    {{ 'Google' | translate }}
                  </span>
                  <div *ngIf="hasGoogleLink" class="ml-2">
                    <div class="text-left">{{ accountGoogle.name }}</div>
                    <div class="text-left">{{ accountGoogle.linkedDate | date:'dd/MM/yyyy' }}</div>
                  </div>
                </div>
                <div *ngIf="hasGoogleLink" class="email">{{ accountGoogle.email }}</div>
                <span *ngIf="!hasGoogleLink" class="text-center" (click)="connectWidthFirebase(LINK_TYPE.GOOGLE)"><a style="color: #1890ff;">{{'linked_account.link' | translate}}</a></span>
                <span *ngIf="hasGoogleLink" class="text-center" (click)="deleteConnectFirebase(LINK_TYPE.GOOGLE)"><a style="color: #FF0004;">{{'linked_account.delete_link' | translate}}</a></span>
              </div>
            </div>
            <div class="divider"></div> 
            <div class="row">
              <!-- Liên kết zalo -->
              <div class="col-12 d-flex justify-content-between align-items-center" style="margin: 14px 0; padding: 0 12px;">
                <div class="d-flex align-items-center" style="min-width: 30%;">
                  <svg width="24" height="24"  class="mr-2" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M22.782 0.166016H27.199C33.2653 0.166016 36.8103 1.05701 39.9572 2.74421C43.1041 4.4314 45.5875 6.89585 47.2557 10.0428C48.9429 13.1897 49.8339 16.7347 49.8339 22.801V27.1991C49.8339 33.2654 48.9429 36.8104 47.2557 39.9573C45.5685 43.1042 43.1041 45.5877 39.9572 47.2559C36.8103 48.9431 33.2653 49.8341 27.199 49.8341H22.8009C16.7346 49.8341 13.1896 48.9431 10.0427 47.2559C6.89583 45.5687 4.41243 43.1042 2.7442 39.9573C1.057 36.8104 0.166016 33.2654 0.166016 27.1991V22.801C0.166016 16.7347 1.057 13.1897 2.7442 10.0428C4.43139 6.89585 6.89583 4.41245 10.0427 2.74421C13.1707 1.05701 16.7346 0.166016 22.782 0.166016Z" fill="#0068FF"/>
                    <path opacity="0.12" fill-rule="evenodd" clip-rule="evenodd" d="M49.8336 26.4736V27.1994C49.8336 33.2657 48.9427 36.8107 47.2555 39.9576C45.5683 43.1045 43.1038 45.5879 39.9569 47.2562C36.81 48.9434 33.265 49.8344 27.1987 49.8344H22.8007C17.8369 49.8344 14.5612 49.2378 11.8104 48.0966L7.27539 43.4267L49.8336 26.4736Z" fill="#001A33"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.779 43.5892C10.1019 43.846 13.0061 43.1836 15.0682 42.1825C24.0225 47.1318 38.0197 46.8954 46.4923 41.4732C46.8209 40.9803 47.1279 40.4677 47.4128 39.9363C49.1062 36.7779 50.0004 33.22 50.0004 27.1316V22.7175C50.0004 16.629 49.1062 13.0711 47.4128 9.91273C45.7385 6.75436 43.2461 4.28093 40.0877 2.58758C36.9293 0.894239 33.3714 0 27.283 0H22.8499C17.6644 0 14.2982 0.652754 11.4699 1.89893C11.3153 2.03737 11.1636 2.17818 11.0151 2.32135C2.71734 10.3203 2.08658 27.6593 9.12279 37.0782C9.13064 37.0921 9.13933 37.1061 9.14889 37.1203C10.2334 38.7185 9.18694 41.5154 7.55068 43.1516C7.28431 43.399 7.37944 43.5512 7.779 43.5892Z" fill="white"/>
                    <path d="M20.5632 17H10.8382V19.0853H17.5869L10.9329 27.3317C10.7244 27.635 10.5728 27.9194 10.5728 28.5639V29.0947H19.748C20.203 29.0947 20.5822 28.7156 20.5822 28.2606V27.1421H13.4922L19.748 19.2938C19.8428 19.1801 20.0134 18.9716 20.0893 18.8768L20.1272 18.8199C20.4874 18.2891 20.5632 17.8341 20.5632 17.2844V17Z" fill="#0068FF"/>
                    <path d="M32.9416 29.0947H34.3255V17H32.2402V28.3933C32.2402 28.7725 32.5435 29.0947 32.9416 29.0947Z" fill="#0068FF"/>
                    <path d="M25.814 19.6924C23.1979 19.6924 21.0747 21.8156 21.0747 24.4317C21.0747 27.0478 23.1979 29.171 25.814 29.171C28.4301 29.171 30.5533 27.0478 30.5533 24.4317C30.5723 21.8156 28.4491 19.6924 25.814 19.6924ZM25.814 27.2184C24.2785 27.2184 23.0273 25.9672 23.0273 24.4317C23.0273 22.8962 24.2785 21.645 25.814 21.645C27.3495 21.645 28.6007 22.8962 28.6007 24.4317C28.6007 25.9672 27.3685 27.2184 25.814 27.2184Z" fill="#0068FF"/>
                    <path d="M40.4867 19.6162C37.8516 19.6162 35.7095 21.7584 35.7095 24.3934C35.7095 27.0285 37.8516 29.1707 40.4867 29.1707C43.1217 29.1707 45.2639 27.0285 45.2639 24.3934C45.2639 21.7584 43.1217 19.6162 40.4867 19.6162ZM40.4867 27.2181C38.9322 27.2181 37.681 25.9669 37.681 24.4124C37.681 22.8579 38.9322 21.6067 40.4867 21.6067C42.0412 21.6067 43.2924 22.8579 43.2924 24.4124C43.2924 25.9669 42.0412 27.2181 40.4867 27.2181Z" fill="#0068FF"/>
                    <path d="M29.4562 29.0944H30.5747V19.957H28.6221V28.2793C28.6221 28.7153 29.0012 29.0944 29.4562 29.0944Z" fill="#0068FF"/>
                  </svg>     
                  <span  class="ml-2">
                  <!-- <span *ngIf="!hasFacebookLink" class="ml-2"> -->
                    {{ 'Zalo' | translate }}
                  </span>
                  <!-- <div *ngIf="hasFacebookLink" class="ml-2">
                    <div class="text-left">{{ accountApple.name }}</div>
                    <div class="text-left">{{ accountApple.linkedDate | date:'dd/MM/yyyy' }}</div>
                  </div> -->
                </div>
                <!-- <div *ngIf="hasFacebookLink" class="email">{{ accountApple.email }}</div>
                <span *ngIf="!hasFacebookLink" class="text-center" (click)="featureInDevelopment()"><a style="color: #1890ff;">{{'linked_account.link' | translate}}</a></span>
                <span *ngIf="hasFacebookLink" class="text-center" (click)="featureInDevelopment()"><a style="color: #FF0004;">{{'linked_account.delete_link' | translate}}</a></span> -->
                <span class="text-center" (click)="featureInDevelopment()"><a style="color: #1890ff;">{{'linked_account.link' | translate}}</a></span>
              </div>
            </div>
            <div class="divider"></div>
        </mat-accordion>

    </mat-card-content>
</mat-card>

<ng-template #confirmDelete>
    <h2 mat-dialog-title style="margin-bottom: 0px !important;">
        {{'alert.confirm' | translate}}
        <button aria-label="Close" (click)="closeConfirmDialog(false)"
                class="close"
                type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </h2>
      <mat-divider></mat-divider>
      <div class="d-flex" style="gap: 8px;">
        <div class="col-2 pr-0" style="text-align: center;padding-left: 0px !important; padding-top: 15px;">
          <em class="fa fa-warning text-primary large"></em>
        </div>
        <div>
          <div *ngIf="linkMode === LINK_TYPE.GOOGLE" style=" padding: 5px 7px 15px; font-size: medium; overflow-wrap: break-word;">
            {{ 'link_google_acount.confirm_delete_link' | translate }}
          </div>
          <div *ngIf="linkMode === LINK_TYPE.ZALO" style=" padding: 5px 7px 15px; font-size: medium; overflow-wrap: break-word;">
            {{ 'link_google_acount.confirm_delete_link_zalo' | translate }}
          </div>
          <div *ngIf="linkMode === LINK_TYPE.APPLE" style=" padding: 5px 7px 15px; font-size: medium; overflow-wrap: break-word;">
            {{ 'link_google_acount.confirm_delete_link_apple' | translate }}
          </div>
          <div *ngIf="linkMode === LINK_TYPE.FACEBOOK" style=" padding: 5px 7px 15px; font-size: medium; overflow-wrap: break-word;">
            {{ 'link_google_acount.confirm_delete_link_facebook' | translate }}
          </div>
        </div>
      </div>
      <div class="justify-content-center" mat-dialog-actions>
        <button mat-stroked-button (click)="closeConfirmDialog(false)" color="primary" cdkFocusInitial class="mr-3" type="button">
          <mat-icon class="mr-0">cancel</mat-icon>
          {{'button.ignore' | translate}}
        </button>
        <button mat-raised-button (click)="closeConfirmDialog('yes')"   color="primary">
          <mat-icon class="mr-0">done</mat-icon>
          {{'button.yes' | translate}}
        </button>
      </div>
</ng-template>

<ng-template #confirmLink>
  <h2 mat-dialog-title style="margin-bottom: 0px !important;">
      {{'link_google_acount.account_password_prompt' | translate}}
      <button aria-label="Close" (click)="linkConfirmDialog(false)"
              class="close"
              type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </h2>
    <mat-divider></mat-divider>
    <form #f="ngForm" (ngSubmit)="f.form.valid && linkConfirmDialog('yes')">
      <div class="row mt-2">
        <div class="col-12">
          <mat-form-field class="w-100">
            <button matSuffix mat-icon-button color="primary" type="button" (click)="showPassword = !showPassword">
              <mat-icon>{{!showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <input matInput [type]="showPassword ? 'text' : 'password'" #focusInput [placeholder]="'form.password' | translate"
              name="currentPassword" id="currentPassword" [(ngModel)]="currentPassword"
              #currentPass="ngModel" required maxlength="100" autocomplete="off" />
            <mat-error *ngIf="f.submitted || currentPass?.errors?.required">
              <span class="text-error">{{'link_google_acount.enter_password' | translate}}</span>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="justify-content-center" mat-dialog-actions>
        <button mat-stroked-button (click)="linkConfirmDialog(false)" color="primary" cdkFocusInitial class="mr-3" type="button">
          <mat-icon class="mr-0">cancel</mat-icon>
          {{'button.ignore' | translate}}
        </button>
        <button mat-raised-button [disabled]="f.form.invalid" type="submit"  color="primary">
          {{'button.continue' | translate}}
          <mat-icon class="mr-0">arrow_forward</mat-icon>
        </button>
      </div>
    </form>
</ng-template>
<ng-template #confirmConnectInSafari>
    <h2 mat-dialog-title style="margin-bottom: 0px !important;">
        {{'alert.confirm' | translate}}
        <button aria-label="Close" (click)="closeSafariDialog()"
                class="close"
                type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </h2>
      <mat-divider></mat-divider>
      <div class="d-flex" style="gap: 8px;">
        <div class="col-2 pr-0" style="text-align: center;padding-left: 0px !important; padding-top: 15px;">
          <em class="fa fa-warning text-primary large"></em>
        </div>
        <div>
          <div style=" padding: 5px 7px 15px; font-size: medium; overflow-wrap: break-word;">
            {{ 'link_google_acount.confirm_safari' | translate }}
          </div>
        </div>
      </div>
      <div class="justify-content-center" mat-dialog-actions>
        <button mat-stroked-button (click)="closeSafariDialog()" color="primary" cdkFocusInitial tabindex="-1" class="mr-3" type="button">
          <mat-icon class="mr-0">cancel</mat-icon>
          {{'button.cancel' | translate}}
        </button>
        <button *ngIf="linkMode === LINK_TYPE.GOOGLE" mat-raised-button (click)="connectWithGoogle()" color="primary">
          <mat-icon class="mr-0">done</mat-icon>
          {{'button.yes' | translate}}
        </button>
        <button *ngIf="linkMode === LINK_TYPE.APPLE" mat-raised-button (click)="connectWithApple()" color="primary">
          <mat-icon class="mr-0">done</mat-icon>
          {{'button.yes' | translate}}
        </button>
      </div>
</ng-template>